import { uploadBytesResumable } from 'firebase/storage'
import { editionImagesRef } from 'firebaseAdapter/storageRefs'
import { EditionImages } from 'firebaseAdapter/types'

const addUpdateEditionMainImage = (id: string, file: File) =>
  uploadBytesResumable(editionImagesRef(id, EditionImages.MAIN), file)

export default addUpdateEditionMainImage
